import { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'datatables.net-bs5';
import "datatables.net-responsive/js/dataTables.responsive.min.js";

function BrokerTable({ brokers }) {
    const tableRef = useRef(null);
    const dataTableRef = useRef(null);

    useEffect(() => {
        if (!brokers || brokers.length === 0) return;

        const $table = $(tableRef.current);

        if (dataTableRef.current) {
            dataTableRef.current.destroy();
            $table.empty();
            dataTableRef.current = null;
        }

        dataTableRef.current = $table.DataTable({
            destroy: true,
            responsive: true,
            colReorder: true,
            data: brokers,
            columns: [
                {
                    data: null,
                    render: (data, type, row, meta) => meta.row + 1,
                    title: "SN"
                },
                {
                    data: 'business_name',
                    title: "Business Name"
                },
                {
                    data: 'broker_code',
                    title: "Code"
                },
                {
                    data: 'industry_type.name',
                    title: "Industry",
                    defaultContent: '-'
                },
                {
                    data: 'owner_contact_no',
                    title: "Owner Contact",
                    defaultContent: '-'
                },
                {
                    data: 'status',
                    title: "Status",
                    render: (data) => `<span class="badge text-bg-${getStatusColor(data)}">${data}</span>`
                },
                {
                    data: 'approved',
                    title: "Approved",
                    render: (data) => data ? '✅' : '❌'
                },
                {
                    data: 'created_at',
                    title: "Created At",
                    render: (data) => new Date(data).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    })
                },
                {
                    data: '_id',
                    title: "Action",
                    className: 'text-end',
                    orderable: false,
                    render: (data) => `<a class="btn btn-sm btn-info" href="/brokers/broker_detail/${data}">View</a>`
                }
            ],
            layout: {
                bottomEnd: {
                    paging: {
                        firstLast: false
                    }
                }
            }
        });

        return () => {
            if (dataTableRef.current) {
                dataTableRef.current.destroy();
                dataTableRef.current = null;
            }
        };
    }, [brokers]);

    if (!brokers || brokers.length === 0) {
        return <p>No brokers found.</p>;
    }

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                className="table table-bordered table-hover table-sm display responsive nowrap"
                id="brokersTable"
                style={{ width: '100%' }}
            >
            </table>
        </div>
    );
}

// Optional: Color-coded status badges
function getStatusColor(status) {
    switch (status) {
        case 'Active':
            return 'success';
        case 'OnHold':
            return 'warning';
        case 'Blocked':
            return 'danger';
        case 'Deactive':
            return 'secondary';
        default:
            return 'light';
    }
}

export default BrokerTable;
